import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgModelExplorer = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#000",
		fillRule: "nonzero",
		d: "M26 22h-4v4h4zm-11 1h4.999L20 21.12c0-.619.488-1.12 1.09-1.12h5.82c.602 0 1.09.501 1.09 1.12v5.76c0 .619-.488 1.12-1.09 1.12h-5.82c-.602 0-1.09-.501-1.09-1.12L19.999 25H14c-.545 0-1-.417-1-1V5H8v1.88C8 7.499 7.512 8 6.91 8H1.09C.489 8 0 7.499 0 6.88V1.12C0 .501.488 0 1.09 0h5.82C7.511 0 8 .501 8 1.12V3h11.999L20 1.12C20 .501 20.488 0 21.09 0h5.82C27.511 0 28 .501 28 1.12v5.76C28 7.499 27.512 8 26.91 8h-5.82C20.489 8 20 7.499 20 6.88L19.999 5 18 4.999V5h-3v8h4.999L20 11.12c0-.619.488-1.12 1.09-1.12h5.82c.602 0 1.09.501 1.09 1.12v5.76c0 .619-.488 1.12-1.09 1.12h-5.82c-.602 0-1.09-.501-1.09-1.12L19.999 15H15zm11-11h-4v4h4zM6 2H2v4h4zm20 0h-4v4h4z"
	})
});
export default SvgModelExplorer;
